export default "__VITE_ASSET__CxjqnRpe__"